export default "__VITE_ASSET__CQeGts$B__"